var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { makeApiEndpointConfig, makeApiGetEndpointConfig } from '../utils/endpoints.utils';
var publicUrlBase = '/public/support-groups';
export var SupportGroupEndpoints = {
    public: {
        index: makeApiEndpointConfig(publicUrlBase),
        get: makeApiGetEndpointConfig(publicUrlBase),
    },
};
export var DefaultSupportGroupIncludes = [
    'facilitator',
    'topic',
];
export var DefaultSupportGroupIncludesForStaff = __spreadArray(__spreadArray([], DefaultSupportGroupIncludes, true), [
    'createdByUser.permissions',
    'facilitator.permissions',
    'reservations.user.permissions',
    'reservations.keyWorker',
    'threads.participants.user',
    'invoiceItems.invoice'
], false);
